import {
  MiddlewareAPI,
  isRejectedWithValue,
  Middleware,
} from "@reduxjs/toolkit";
import { logoutAction } from "src/app/slices/authSlice";

export const rtkQueryErrorHandler: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      if (action?.payload?.status === 401) {
        next(logoutAction());
      }
    }

    return next(action);
  };
